import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'

// ── 商品订单 ──────────────────────────────────────────────────────────────────

export function getProductOrderList(data) {
  return request({ url: '/admin/product-order/list', method: 'post', data })
}

export function getProductOrderDetail(data) {
  return request({ url: '/admin/product-order/detail', method: 'post', data })
}

export function getRefundableAmount(data) {
  return request({ url: '/admin/product-order/refundableAmount', method: 'post', data })
}

export function getRefundableServiceOrders(data) {
  return request({ url: '/admin/product-order/refundableServiceOrders', method: 'post', data })
}

export function refundProductOrder(data) {
  return request({ url: '/admin/product-order/refund', method: 'post', data })
}

export function getProductOrderRefundRecords(data) {
  return request({ url: '/admin/product-order/refundRecords', method: 'post', data })
}

export function getProductOrderServiceList(data) {
  return request({ url: '/admin/product-order/serviceOrderList', method: 'post', data })
}

export function getUserProductOrders(data) {
  return request({ url: '/admin/product-order/userOrders', method: 'post', data })
}

// ── 服务订单 ──────────────────────────────────────────────────────────────────

export function getServiceOrderList(data) {
  return request({ url: '/admin/service-order/list', method: 'post', data })
}

export function getServiceOrderDetail(data) {
  return request({ url: '/admin/service-order/detail', method: 'post', data })
}

export function assignCollector(data) {
  return request({ url: '/admin/service-order/assignCollector', method: 'post', data })
}

export function assignPartner(data) {
  return request({ url: '/admin/service-order/assignPartner', method: 'post', data })
}

export function uploadReport(serviceOrderId, file) {
  const formData = new FormData()
  formData.append('service_order_id', serviceOrderId)
  formData.append('file', file)
  return axios.post(process.env.VUE_APP_BASE_API + '/admin/service-order/uploadReport', formData, {
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.data.code !== 0) throw new Error(res.data.message || '上传失败')
    return res.data
  })
}
